import {
  Box,
  Checkbox,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  Tooltip
} from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import _ from 'lodash';
import React, { Component } from 'react';
import ClearIcon from '@mui/icons-material/Clear';
import DateRange from 'src/components/common/DateRange';
import goodalipi from 'src/plugins/goodalipi';

class AhcDashboardToolbar extends Component {
  constructor(props) {
    super(props);
    this.state = this.props.filter;
    this.globalHR = goodalipi.get('globalHR');
  }
  handleChange(type, value) {
    let { location, campus, duration, bene, payment, entityRequested } =
      this.setState;
    console.log('line 28', this.setState.location);
    switch (type) {
      case 'location':
        location = value;
        break;
      case 'campus':
        campus = value;
        break;
      case 'duration':
        duration = value;
        break;
      case 'bene':
        bene = value;
        break;
      case 'payment':
        payment = value;
        break;
      case 'entityRequested':
        entityRequested = value;
        break;
    }
    let obj = {};
    if (location) {
      obj.location = location;
    }
    if (duration) {
      obj.dateRange = duration;
    }
    if (bene) {
      obj.bene = bene;
    }
    if (campus) {
      obj.campus = campus;
    }
    if (payment) {
      obj.payment = payment;
    }
    if (entityRequested) {
      obj.entityRequested = entityRequested;
    }
    this.setState(obj, () => {
      this.props.setFilters(this.state);
    });
  }
  renderLabel(selected) {
    let arr = [];
    selected.forEach((each) => {
      this.props.filterOptions.locationList.forEach((element) => {
        if (element.val == each) {
          arr.push(element.key.toString());
        }
      });
    });
    return arr.join(', ');
  }
  render() {
    return (
      <Grid direction="row" container spacing={3}>
        <Grid item xs={12} sm={2}>
          <FormControl size="small" fullWidth variant="outlined">
            <InputLabel>Location</InputLabel>
            <Select
              multiple
              value={this.state.location}
              onChange={(ev) => {
                this.handleChange('location', ev.target.value);
              }}
              renderValue={(selected) => this.renderLabel(selected)}
              label="Location"
            >
              {this.props.filterOptions.locationList.map((val, idx) => (
                <MenuItem sx={{ py: 0 }} value={val.val} key={idx}>
                  <Checkbox
                    color="primary"
                    size="small"
                    checked={
                      this.state.location.length &&
                      this.state.location.indexOf(val.val) > -1
                    }
                  />
                  <ListItemText primary={val.key} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        {this.globalHR && (
          <Grid item xs={12} sm={1.5}>
            <FormControl size="small" fullWidth variant="outlined">
              <InputLabel>EntityId</InputLabel>
              <Select
                // multiple
                value={this.state.entityRequested}
                onChange={(ev) => {
                  this.handleChange('entityRequested', ev.target.value);
                }}
                // renderValue={(selected) => selected.join(', ')}
                label="EntityId"
              >
                {this.props.filterOptions.entityRequested.map((val, idx) => (
                  <MenuItem sx={{ py: 0 }} value={val.val} key={idx}>
                    <ListItemText primary={val.key} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        )}

        <Grid item xs={12} sm={1.6}>
          <FormControl size="small" fullWidth variant="outlined">
            <InputLabel>Provider</InputLabel>
            <Select
              multiple
              value={this.state.campus}
              onChange={(ev) => {
                this.handleChange('campus', ev.target.value);
              }}
              renderValue={(selected) => selected.join(', ')}
              label="Campus"
            >
              {this.props.filterOptions.campusList.map((val, idx) => (
                <MenuItem sx={{ py: 0 }} value={val} key={idx}>
                  <Checkbox
                    color="primary"
                    size="small"
                    checked={
                      this.state.campus.length &&
                      this.state.campus.indexOf(val) > -1
                    }
                  />
                  <ListItemText primary={val} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={3}>
          <DateRange
            noHelperText={true}
            helperTextValue={'Subscription'}
            boxsize="small"
            onDateChange={(value) => {
              this.handleChange('duration', value);
            }}
          />
        </Grid>
        <Grid item xs={12} sm={1.8}>
          <FormControl size="small" fullWidth variant="outlined">
            <InputLabel>Payment Type</InputLabel>
            <Select
              // multiple
              value={this.state.payment}
              onChange={(ev) => {
                this.handleChange('payment', ev.target.value);
              }}
              // renderValue={(selected) => selected.join(', ')}
              label="payment"
            >
              {this.props.filterOptions.paymentList.map((val, idx) => (
                <MenuItem sx={{ py: 0 }} value={val} key={idx}>
                  <ListItemText primary={val} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={1.5}>
          <FormControl size="small" fullWidth variant="outlined">
            <InputLabel>Beneficiary</InputLabel>
            <Select
              multiple
              value={this.state.bene}
              onChange={(ev) => {
                this.handleChange('bene', ev.target.value);
              }}
              renderValue={(selected) => selected.join(', ')}
              label="Beneficiary"
            >
              {this.props.filterOptions.beneList.map((val, idx) => (
                <MenuItem sx={{ py: 0 }} value={val} key={idx}>
                  <Checkbox
                    color="primary"
                    size="small"
                    checked={
                      this.state.bene.length &&
                      this.state.bene.indexOf(val) > -1
                    }
                  />
                  <ListItemText primary={val} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item sx={{ width: '50px', marginLeft: '10px' }}>
          <Tooltip title="Refresh">
            <IconButton
              size="small"
              sx={{ bgcolor: 'white', boxShadow: '0 0 4px rgba(0,0,0,0.20)' }}
              onClick={() => this.props.onRefresh()}
              color="primary"
              aria-label="refresh"
            >
              <Refresh />
            </IconButton>
          </Tooltip>
        </Grid>
        <Grid
          item
          sx={{ width: '70px', marginTop: '-32px' }}
          container
          alignContent="center"
          justifyItems="center"
        >
          <Tooltip title="Reset">
            <IconButton
              sx={{
                bgcolor: 'white',
                boxShadow: '0 0 4px rgba(0,0,0,0.31)'
              }}
              color="primary"
              size="small"
              onClick={() => window.location.reload()}
            >
              <ClearIcon color="primary" />
            </IconButton>
          </Tooltip>
        </Grid>
        {false && (
          <>
            <Grid item xs={12} sm>
              <FormControl size="small" fullWidth variant="outlined">
                <InputLabel>Package type</InputLabel>
                <Select
                  multiple
                  // value={campLocation}
                  // onChange={(e) => setCampLocation(e.target.value)}
                  // renderValue={(selected) => selected.join(', ')}
                  label="Department"
                >
                  {/* {
            selectionData && selectionData.campLocation && selectionData.campLocation.length ?
              selectionData.campLocation.map((val, idx) => (
                <MenuItem sx={{ py: 0 }} value={val} key={idx}>
                  <Checkbox
                    color="primary"
                    size="small" checked={campLocation.indexOf(val) > -1} />
                  <ListItemText primary={val} />
                </MenuItem>
              )) : null
          } */}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm>
              <FormControl size="small" fullWidth variant="outlined">
                <InputLabel>Payment Type</InputLabel>
                <Select
                  multiple
                  // value={campLocation}
                  // onChange={(e) => setCampLocation(e.target.value)}
                  // renderValue={(selected) => selected.join(', ')}
                  label="Department"
                >
                  {/* {
            selectionData && selectionData.campLocation && selectionData.campLocation.length ?
              selectionData.campLocation.map((val, idx) => (
                <MenuItem sx={{ py: 0 }} value={val} key={idx}>
                  <Checkbox
                    color="primary"
                    size="small" checked={campLocation.indexOf(val) > -1} />
                  <ListItemText primary={val} />
                </MenuItem>
              )) : null
          } */}
                </Select>
              </FormControl>
            </Grid>
          </>
        )}
      </Grid>
    );
  }
}

export default AhcDashboardToolbar;
